import React, { useRef } from 'react';
import { EditorContent } from '@tiptap/react';
import { Form, Input, TextArea } from 'semantic-ui-react';

import { Toolbar } from '../tiptap/Toolbar';
import { useEntryTiptap } from '../tiptap/useEntryTiptap';
import ActionsBar from './ActionsBar';
import { DescriptionProps } from './Description.types';

export const Description = (props: DescriptionProps) => {
  const { onCancel, onChange, descriptionProperties, isSaving } = props;
  const imageInputRef = useRef<HTMLInputElement | null>(null);
  const { editor, onImageFileChange, onIndent, onOutdent, promptForImage, promptForLink } = useEntryTiptap({
    value: descriptionProperties?.value,
    onChange: value => onChange({ field: 'editorValue', value })
  });

  const onActionsBarSave = () => {
    const { onSave } = props;
    const { title, value, citation } = descriptionProperties;
    onSave({ title, value, citation });
  };

  return (
    <div className='entryDescription'>
      <Form>
        <label>Title (80 characters max.)</label>
        <Input
          fluid
          value={descriptionProperties?.title}
          onChange={(e, data) => {
            onChange({ field: 'title', value: data.value });
          }}
          placeholder='New Data Entry'
          maxLength='80'
        />

        <label>Description</label>
        <div className='entryEditor'>
          {editor && (
            <>
              <Toolbar
                editor={editor}
                onIndent={onIndent}
                onOutdent={onOutdent}
                onPromptForImage={promptForImage}
                onPromptForLink={promptForLink}
                onUploadImage={() => imageInputRef.current?.click()}
              />
              <input
                ref={imageInputRef}
                className='tiptapToolbarFileInput'
                type='file'
                accept='image/*'
                onChange={onImageFileChange}
              />
              <EditorContent editor={editor} />
            </>
          )}
        </div>

        <label>Citation / Source</label>
        <TextArea
          rows={5}
          value={descriptionProperties?.citation}
          onChange={(e, data) => {
            onChange({ field: 'citation', value: data.value as any });
          }}
        />

        <ActionsBar
          isSaving={isSaving}
          onSave={onActionsBarSave}
          onCancel={onCancel}
        />
      </Form>
    </div>
  );
};
